import axios from "axios";
import { __ } from "@wordpress/i18n";
import Popup from "../components/popup";
import FormValidator from "../utils/form-validator";

const {
	NinetyNineData: { ajaxurl, recaptchaNonce, checkCardBalanceNonce },
} = window;

export default class {
	constructor() {
		this.popupElement = document.querySelector(".gift-card-popup");

		if (!this.popupElement) {
			return;
		}

		this.popup = new Popup(this.popupElement);

		this.form = this.popupElement.querySelector("form");
		this.submitButton = this.form.querySelector("button");
		this.cardNumberField = this.form.querySelector('[name="gift-card-number"]');
		this.cardPinField = this.form.querySelector('[name="gift-card-pin"]');

		this.loadingDots = this.popupElement.querySelector(".loading-dots");
		this.successMessage = this.popupElement.querySelector("p.success-message");
		this.errorMessage = this.popupElement.querySelector("p.error-message");
		this.balance = this.successMessage.querySelector(".balance");

		this.pinCardPattern = this.cardPinField.dataset.pinCardPattern;
		this.recaptchaResponse = false;

		this.disableForm();
		this.addEventListeners();

		this.validator = new FormValidator(this.form);

		if ("#balance-check" === window.location.hash) {
			this.popup.open();
		}
	}

	addEventListeners() {
		this.form.addEventListener("submit", e => {
			e.preventDefault();
			this.submitForm();
		});

		this.cardNumberField.addEventListener(
			"input",
			this.togglePinField.bind(this)
		);

		document.addEventListener("click", e => {
			if (
				"A" === e.target.tagName &&
				e.target.classList.contains("gift-card-popup-open")
			) {
				e.preventDefault();
				this.popup.open();
			}
		});
	}

	togglePinField(e) {
		if (!this.pinCardPattern) {
			return;
		}

		const regex = new RegExp(this.pinCardPattern);
		const disabled = !regex.exec(e.target.value);

		if (disabled !== this.cardPinField.disabled) {
			this.cardPinField.disabled = disabled;
		}

		if (this.cardPinField.disabled) {
			this.validator.validateField(this.cardPinField);
		}
	}

	initReCaptcha() {
		const { grecaptcha } = window;
		const recaptchaElement = this.popupElement.querySelector(".recaptcha");

		this.recaptcha = grecaptcha.render(recaptchaElement, {
			sitekey: recaptchaElement.getAttribute("data-sitekey"),
			callback: response => {
				this.recaptchaResponse = response;
				this.enableForm();
			},
			"expired-callback": () => {
				this.disableForm();
			},
		});
	}

	validateReCaptcha() {
		const promise = axios({
			method: "post",
			url: ajaxurl,
			params: {
				action: "nnr_recaptcha_verify",
				_wpnonce: recaptchaNonce,
				response: this.recaptchaResponse,
			},
		});

		this.resetReCaptcha();

		return promise;
	}

	resetReCaptcha() {
		window.grecaptcha.reset(this.recaptcha);
		this.recaptchaResponse = null;
		this.disableForm();
	}

	async submitForm() {
		this.loadingDots.classList.add("is-visible");
		this.errorMessage.classList.remove("is-visible");
		this.successMessage.classList.remove("is-visible");

		const recaptchaError = __(
			"reCAPTCHA validation failed. Please try again.",
			"ninety-nine"
		);

		try {
			if (!this.recaptchaResponse) {
				throw new Error(recaptchaError);
			}

			const {
				data: { success: recaptchaSuccess },
			} = await this.validateReCaptcha();

			if (false === recaptchaSuccess) {
				throw new Error(recaptchaError);
			}

			const params = {
				action: "nnr_check_card_balance",
				_wpnonce: checkCardBalanceNonce,
				card_number: this.cardNumberField.value,
			};

			if (!this.cardPinField.disabled) {
				params.reg_code = this.cardPinField.value;
			}

			const {
				data: { success, data },
			} = await axios({
				method: "post",
				url: ajaxurl,
				params,
			});

			if (false === success) {
				throw new Error(data);
			}

			this.balance.innerText = `$${data}`;
			this.successMessage.classList.add("is-visible");
			this.cardPinField.value = "";
		} catch (error) {
			this.errorMessage.innerText = error.message;
			this.errorMessage.classList.add("is-visible");
		}

		this.loadingDots.classList.remove("is-visible");
	}

	enableForm() {
		this.submitButton.disabled = false;
	}

	disableForm() {
		this.submitButton.disabled = true;
	}
}
